import type { FormErrors } from '../types/forms'

export const getError = (
  errors: FormErrors,
  fieldName: string
): string | undefined => {
  if (fieldName === 'error') return errors.error

  const fieldErrors = errors.errors?.[fieldName]
  return fieldErrors?.length ? fieldErrors.join(', ') : undefined
}
